<template>
	<div class="v-translations">

		<table class="st-table st-table--full">
			<thead>
				<tr>
					<th>Dev Englisch</th>
					<th v-for="(messages, langcode) in $i18n.messages">{{ $t(langcode) }}</th>
				</tr>
			</thead>
			<tbody>
				<tr  v-for="(value, defaultValue) in $i18n.messages.en">
					<td>{{ defaultValue }}</td>
					<td v-for="(messages, langcode) in $i18n.messages">
						{{ messages[defaultValue] }}
					</td>
				</tr>
			</tbody>
		</table>
	</div>
</template>

<script>
export default {
	name: 'v-translations'
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/p-translations.vue